import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommentariesItemComponent } from './components/commentaries-item/commentaries-item.component';
import { SvgComponent } from 'projects/shared/src/lib/core/components/svg-component/svg-component.component';
import { CommentaryItemInterface } from 'projects/shared/src/lib/core/interfaces';

@Component({
  selector: 'app-commentaries',
  imports: [
    CommonModule,
    CommentariesItemComponent,
    TranslateModule,
    MatButtonModule,
    SvgComponent,
    MatDialogModule,
  ],
  templateUrl: './commentaries.component.html',
  styleUrls: ['./commentaries.component.scss'],
})
export class CommentariesComponent {
  @Input() commentaries: CommentaryItemInterface[] = [];
  @Input() isShowList = true;
  @Input() isShowCreateComment = true;
  @Output('onAdd') addNewCommentary = new EventEmitter();

  public newComment = '';

  public onValueChange(event: any): void {
    this.newComment = event.target.value;
  }

  public handleNewComment(): void {
    if (!this.newComment.length) return;

    this.addNewCommentary.emit(this.newComment);
    this.newComment = '';
  }
}
